<div class="overlay" *ngIf="isOpen" (click)="closePanel()"></div>
<div class="notification-panel" [class.visible]="isOpen">
  <app-notifications-header
    (close)="closePanel()"
    (markRead)="markAllNotificationsAsRead()"
    (viewUnreadOnlyChange)="handleViewUnreadOnlyChange($event)">
  </app-notifications-header>
  
  <div class="notifications-content">
    <p *ngIf="filteredNotifications.length === 0" class="notification-empty">
      {{ 'label.no_new_notifications' | translate }}
    </p>
  
    <ul class="notification-list" *ngIf="filteredNotifications.length > 0">
      <li 
        *ngFor="let notification of filteredNotifications"
        class="notification-item"
        (click)="onNotificationClick(notification)"
      >
        <div class="icon">
          <i class="bi bi-person-circle user-avatar-icon"></i>
        </div>
        <div class="details">
          <div class="action-and-message">
            <span class="action-by-user-id">{{ notification.actionByUserFullName }}</span>
            <span class="message" [innerHTML]="notification.message"></span>
          </div>
          <div class="reference-id">
            <span class="title">{{ notification.referenceTitle }} </span>            
            <span class="dot">&bull;</span>
            <span class="id"> {{ notification.referenceIdentifier }}</span>
          </div>
          <div class="metadata">
            <span class="title">{{ notification.actionType }}</span>
            <span class="dot">&bull;</span>
            <span class="timestamp">{{ helperService.adjustDateFormatToUTCByAddingZ(notification.timestamp) | date: 'MMM d, y • HH:mm' }}</span>
          </div>
        </div>
        <span *ngIf="notification.status === 'New'" class="badge">
          {{ 'label.new' | translate }}
        </span>
      </li>
    </ul>
  </div>
